import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { LoginService } from '../../login/login.service';
import { RegisterNewFamilyVerifyCodeComponent } from '../register-new-family-verify-code/register-new-family-verify-code.component';
 

@Component({
  selector: 'app-register-new-family-message',
  templateUrl: './register-new-family-message.component.html',
  styleUrls: [
    './register-new-family-message.component.css',
    '../familiy-registration-shared-style.css'
  ]
})
export class RegisterNewFamilyMessageComponent implements OnInit {
  interpolatedString: string;

  constructor(
    private dialogRef: MatDialogRef<RegisterNewFamilyMessageComponent>,
    private dialog: MatDialog,
    private loginService: LoginService
  ) { }

  enableSelfRegistrationCode = false;

  ngOnInit() {
    this.interpolatedString = 'This was interpolated';
    this.enableSelfRegistrationCode  = this.loginService.LoginSettings.EnableSelfRegistrationCode;
  }

  modalInstancePreviousClick = function () {
    this.dialogRef.close('Select Language');
  };

  modalInstanceNextClick = function () {
    this.dialogRef.close('Register New Family');
  };

  modalInstanceCancelClick = function () {
    this.dialogRef.close('Cancel was clicked.');
  };

  alreadyHaveCodeClick = function () {
    this.dialog.open(RegisterNewFamilyVerifyCodeComponent, {
      disableClose: true,
      width: '500px',
      panelClass: 'tyl-mat-dialog'
    });
    this.dialogRef.close('Cancel was clicked.');
  };

}
